/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { FragmentsDeliveryGetStationConfigConfigQueryResponse, FragmentsDeliveryGetStationConfigConfigPathParams, FragmentsDeliveryGetStationConfigConfig401, FragmentsDeliveryGetStationConfigConfig403 } from "../models/FragmentsDeliveryGetStationConfigConfig";

export function getFragmentsDeliveryGetStationConfigConfigUrl(stationId: FragmentsDeliveryGetStationConfigConfigPathParams["stationId"]) {
  const res = { method: 'GET', url: `/fragments-delivery/v1/station-config/${stationId}` as const }
  return res
}

/**
 * @summary Get Station config (client access)
 * {@link /fragments-delivery/v1/station-config/:stationId}
 */
export async function fragmentsDeliveryGetStationConfigConfig(stationId: FragmentsDeliveryGetStationConfigConfigPathParams["stationId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<FragmentsDeliveryGetStationConfigConfigQueryResponse, ResponseErrorConfig<FragmentsDeliveryGetStationConfigConfig401 | FragmentsDeliveryGetStationConfigConfig403>, unknown>({ method : "GET", url : getFragmentsDeliveryGetStationConfigConfigUrl(stationId).url.toString(), ... requestConfig })
  return res.data
}